const constants = {
  STATIC_DATE_RANGE_LIST: [
    { label: '2 days', value: 2 },
    { label: '1 week', value: 7 },
    { label: '2 week', value: 14 }
  ],
  DISPLAY_DATE_FORMAT: 'MM/dd/yy',
  LAST_ONE_WEEK: 7,
  API_MESSAGES: {
    FAILED_TO_FETCH: 'Error while fetching message history, please retry',
    NOT_FOUND: 'Message history not found!',
    FETCH_IN_PROGRESS: 'Fetching message history, please wait...',
    DRIVERS_NOT_AVAILABLE: 'Driver list not available!'
  },
  VALIDATION_MESSAGE: {
    REQUIRED: '* Required',
    INVALID_TIME_PERIOD_INPUT: '* Invalid time range'
  },
  GROUPED_DATE_MESSAGE_FORMAT: 'd MMMM yy, EEEE',
  DRIVER_NUMBER_PARAMS: {
    placeholder: "Enter Driver Number",
    format: /^[a-zA-Z0-9]{1,20}$/, // twelve digit regex 
  }
};

export default constants;
